import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  CheckCircle, 
  Calendar,
  CreditCard,
  Users,
  Clock,
  BookOpen
} from 'lucide-react';
import FEMRegistrationModal from './FEMRegistrationModal';

const benefits = [
  'Comprehensive export training materials',
  'One-on-one mentorship sessions',
  'Access to buyer network',
  'Export documentation templates',
  'Certificate of completion',
  'Post-program support',
  'Alumni network access',
  'Business growth resources'
];

const FEMRegistration = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleEnrollClick = () => setIsOpen(true);

const handleBrochureDownload = () => {
    window.open('https://drive.google.com/file/d/1EMdQlGpy508s_rq_Ja_Yr01h7v3m7Yvp/view?usp=sharing', '_blank');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Benefits */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              What You'll Get
            </h2>

            <div className="grid gap-4">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-center bg-green-50 rounded-lg p-4"
                >
                  <CheckCircle className="h-5 w-5 text-green-600 mr-3 flex-shrink-0" />
                  <span className="text-gray-800">{benefit}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Column - Registration Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Register for the Masterclass
              </h3>

              <div className="space-y-6 mb-8">
                <div className="flex items-center">
                  <Calendar className="h-5 w-5 text-green-600 mr-3" />
                  <div>
                    <div className="font-medium text-gray-900">Registration</div>
                    <div className="text-gray-600">Always Open</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <Clock className="h-5 w-5 text-green-600 mr-3" />
                  <div>
                    <div className="font-medium text-gray-900">Time</div>
                    <div className="text-gray-600">Convenient</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <Users className="h-5 w-5 text-green-600 mr-3" />
                  <div>
                    <div className="font-medium text-gray-900">Class</div>
                    <div className="text-gray-600">LIVE</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <BookOpen className="h-5 w-5 text-green-600 mr-3" />
                  <div>
                    <div className="font-medium text-gray-900">Learning Format</div>
                    <div className="text-gray-600">Virtual + Mentorship Sessions</div>
                  </div>
                </div>

                <div className="flex items-center">
                  <CreditCard className="h-5 w-5 text-green-600 mr-3" />
                  <div>
                    <div className="font-medium text-gray-900">Investment</div>
                    <div className="text-2xl font-bold text-green-600">₦60,000</div>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <button
                  onClick={handleEnrollClick}
                  className="w-full py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
                >
                  Register Now
                </button>

                <button onClick={handleBrochureDownload} className="w-full py-4 border-2 border-green-600 text-green-600 rounded-lg font-semibold hover:bg-green-50 transition-colors">
                  Download Course Outline
                </button>
              </div>

              <p className="mt-6 text-sm text-gray-600 text-center">
                Need more information? Contact our program advisor at{' '}
                <a href="mailto:advisor@lsem.edu.ng" className="text-green-600 hover:text-green-700">
                  info@lsem.org.ng
                </a>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
        <FEMRegistrationModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </section>
  );
};

export default FEMRegistration;